import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=33add7ff"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"
import style0 from "./demo.vue?vue&type=style&index=0&id=33add7ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports